import UtilsLayout from '../components/layouts/UtilsLayout.vue';
import UtilsIndexPage from '../pages/UtilsIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/utils',
        name: 'utils.root',
        component: UtilsLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'utils.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /utils
                path: '',
                name: 'UtilsIndexPage',
                component: UtilsIndexPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /utils/create
            //   name: 'utils.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
